var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.842102,
    y: 0.421875,
    width: 49.6842,
    height: 49.6842,
    rx: 24.8421,
    fill: "#D7DBEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 12.8418C27.3313 12.8418 28.911 13.4961 30.0757 14.6608C31.2404 15.8255 31.8947 17.4052 31.8947 19.0523C31.8947 20.6995 31.2404 22.2791 30.0757 23.4438C28.911 24.6085 27.3313 25.2628 25.6842 25.2628C24.037 25.2628 22.4574 24.6085 21.2927 23.4438C20.128 22.2791 19.4736 20.6995 19.4736 19.0523C19.4736 17.4052 20.128 15.8255 21.2927 14.6608C22.4574 13.4961 24.037 12.8418 25.6842 12.8418ZM25.6842 28.3681C32.5468 28.3681 38.1052 31.1473 38.1052 34.5786V37.6839H13.2631V34.5786C13.2631 31.1473 18.8215 28.3681 25.6842 28.3681Z",
    fill: "#374DA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogo);
export default __webpack_public_path__ + "static/media/UserLogo.04b1c478a3f8b81fb1d260d7a4ec1c02.svg";
export { ForwardRef as ReactComponent };